import { render } from "./RearrangeStructureDialog.vue?vue&type=template&id=41afa5dc&scoped=true"
import script from "./RearrangeStructureDialog.vue?vue&type=script&lang=js"
export * from "./RearrangeStructureDialog.vue?vue&type=script&lang=js"

import "./RearrangeStructureDialog.vue?vue&type=style&index=0&id=41afa5dc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41afa5dc"]])

export default __exports__